export const setFormReadonly = (
    {
        registry,
        readonly,
    }: {
        registry: Map<
            string,
            Vue & {
                $parent: {
                    setReadonly: ({ value }: { value?: boolean }) => void;
                };
                $el?: {
                    classList: {
                        contains: (className: string) => boolean;
                        add: (className: string) => void;
                        remove: (className: string) => void;
                    };
                };
            }
        >;
        readonly?: boolean;
    } = {
        registry: new Map(),
        readonly: true,
    }
) => {
    const fields = [...registry.values()];

    fields.forEach((field) => {
        field?.$parent?.setReadonly?.({ value: readonly });
    });
};
